<span><span class="mr-2 glyphicon-warning text-warning" v-if="warning" v-translate="warning"></span><span :class="fieldClass">{{ modelLocal }}</span></span>